module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QzJuqB/images/cover.jpg?1700070684414",
      "alt": "This image is the cover for the book Westminster College, Campus History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Westminster College, Campus History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("During the mid-1800s, a small band of farsighted men convened to form a college for �the mental and moral training of youth.� They also pledged that �no person will be refused admission on account of Color, Caste or Sex.� This was a bold move on the eve of the Civil War. As Presbyterian Church representatives, the founders selected the name Westminster Collegiate Institute. In 1852, Westminster became the first integrated and unrestricted coeducational college in the country. Today it is one of America�s most admired small liberal arts colleges. Westminster remains on the cutting edge of teaching and learning while valuing the interaction between faculty and students. The New Wilmington campus has been home to successive generations of scholars who have gone on to excel in"), _c('br'), _vm._v("a wide range of endeavors. Westminster College serves as a tribute to the school�s past and present students, preserving the images of their special"), _c('br'), _vm._v("memories and favorite places.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Braden Guffey, Debora Swatsworth Foster\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Authors Barbara Braden Guffey and Debora Swatsworth Foster both graduated from Westminster and are current members of its board of trustees. R. Thomas Williamson, Westminster�s 13th president, contributed the foreword.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0